import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SceneEnvironment.tsx
import { Sky, Billboard } from '@react-three/drei';
import * as THREE from 'three';
import { useThree } from "@react-three/fiber";
import { useEffect } from "react";
import { RoomEnvironment } from 'three/examples/jsm/environments/RoomEnvironment.js';
const GRASS_COLOR = '#ebfdd7';
const GRASS_FAR_COLOR = '#4a6a2e';
function TreeBillboard({ position, scale = 1 }) {
    return (_jsxs(Billboard, { position: position, follow: true, children: [_jsxs("mesh", { children: [_jsx("planeGeometry", { args: [4, 6] }), _jsx("meshBasicMaterial", { color: "#3d6b2a", transparent: true, opacity: 0.85, side: THREE.DoubleSide, depthWrite: false })] }), _jsxs("mesh", { position: [0, 1, 0.01], children: [_jsx("circleGeometry", { args: [1.8, 8] }), _jsx("meshBasicMaterial", { color: "#2d5a1a", transparent: true, opacity: 0.7, side: THREE.DoubleSide, depthWrite: false })] }), _jsxs("mesh", { position: [-1.2, 0.2, 0.01], children: [_jsx("circleGeometry", { args: [1.3, 8] }), _jsx("meshBasicMaterial", { color: "#4a7a30", transparent: true, opacity: 0.6, side: THREE.DoubleSide, depthWrite: false })] }), _jsxs("mesh", { position: [1.2, 0.2, 0.01], children: [_jsx("circleGeometry", { args: [1.3, 8] }), _jsx("meshBasicMaterial", { color: "#3d6b24", transparent: true, opacity: 0.6, side: THREE.DoubleSide, depthWrite: false })] }), _jsxs("mesh", { position: [0, -2.5, 0.01], children: [_jsx("planeGeometry", { args: [0.4, 2] }), _jsx("meshBasicMaterial", { color: "#5c3d1a", side: THREE.DoubleSide })] })] }));
}
function EnvLighting() {
    const { gl, scene } = useThree();
    useEffect(() => {
        const pmrem = new THREE.PMREMGenerator(gl);
        const envTex = pmrem.fromScene(new RoomEnvironment(), 0.04).texture;
        scene.environment = envTex;
        return () => {
            scene.environment = null;
            envTex.dispose();
            pmrem.dispose();
        };
    }, [gl, scene]);
    return null;
}
export function SceneEnvironment({ size = 60, sky = true, floor = true, tree = 0 }) {
    // деревья далеко за краем газона
    const trees = [
    // [-size * 0.7,  3, -size * 0.5],
    // [ size * 0.7,  3, -size * 0.5],
    // [-size * 0.85, 4, -size * 0.3],
    // [ size * 0.85, 4, -size * 0.3],
    // [-size * 0.6,  2.5, -size * 0.65],
    // [ size * 0.6,  2.5, -size * 0.65],
    // [-size * 0.95, 3.5, -size * 0.15],
    // [ size * 0.95, 3.5, -size * 0.15],
    ];
    return (_jsxs(_Fragment, { children: [_jsx(EnvLighting, {}), sky ? (_jsx(Sky, { distance: 450000, sunPosition: [100, 30, 100], inclination: 0.49, azimuth: 0.25, turbidity: 6, rayleigh: 0.3 })) : null, floor ? (_jsxs("mesh", { rotation: [-Math.PI / 2, 0, 0], position: [0, -0.01, 0], receiveShadow: true, children: [_jsx("planeGeometry", { args: [size * 4, size * 4] }), _jsx("meshLambertMaterial", { color: GRASS_COLOR })] })) : null, tree > 0 && trees.map((pos, i) => (_jsx(TreeBillboard, { position: pos, scale: 0.8 + Math.random() * 0.6 }, i)))] }));
}
